import { mapGetters } from 'vuex'

export default {
  watch: {
    sportClub: {
      immediate: true,
      handler(newVal) {
        this.handleClubTypeChange(newVal, this.sportType)
      }
    },
    sportType: {
      immediate: true,
      handler(newVal) {
        this.handleClubTypeChange(newVal, this.sportClub)
      }
    }
  },
  computed: {
    ...mapGetters({
      sportType: 'search/searchSportType',
      sportClub: 'search/searchSportClub'
    })
  },
  methods: {
    handleClubTypeChange(newChosenItem, oppositeItem) {
      if (newChosenItem) {
        this.search = newChosenItem.title
        this.chosenItem = newChosenItem
      } else if (oppositeItem) {
        this.chosenItem = oppositeItem
        this.search = oppositeItem.title
      } else {
        this.search = this.chosenItem = ''
      }
    }
  }
}
